import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { createAppRouter } from './router'
import './styles.css'

const router = createAppRouter()
const kok = document.getElementById('root')!

/**
 * Router'a "bu sayfa sunucuda çizildi" bilgisi. TanStack bunu normalde kendi
 * hydrate akışında (`RouterClient`) ayarlar; biz tam belgeyi değil yalnızca
 * `#root` içini ön-render ettiğimiz için o akışı kullanmıyoruz. `ssr` boşken
 * tarayıcı kök rotayı Suspense ile sarıyor, sunucu sarmıyor ve hydrate
 * uyuşmuyordu (React #418). İç alan olduğu için tip dışına çıkılıyor;
 * sürüm yükseltmede `pnpm build` sonrası tarayıcı konsolunda hydrate hatası
 * olmadığı doğrulanmalı.
 */
if (kok.firstElementChild) {
  ;(router as unknown as { ssr: unknown }).ssr = true
}
const agac = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)

// Üretimde sayfa ön-render edilmiş gelir (scripts/prerender.mjs): var olan
// HTML'e bağlanırız, yeniden çizmeyiz. Geliştirmede kökte yalnızca yer tutucu
// yorum vardır; eleman çocuğu yoktur (yorum düğümü hydrate'i yanıltmasın).
if (kok.firstElementChild) {
  void router.load().then(() =>
    hydrateRoot(kok, agac, {
      // Uyuşmazlık olursa React istemciden yeniden çizer ama sayfa gecikir.
      // Mesajı saklıyoruz ki konsoldan tam metni okunabilsin.
      onRecoverableError: (hata) => {
        const w = window as Window & { __hydrateHatalari?: string[] }
        ;(w.__hydrateHatalari ??= []).push(String((hata as Error)?.message ?? hata))
        console.error(hata)
      },
    }),
  )
} else {
  createRoot(kok).render(agac)
}
